import CreateTemplateComp from "../component/CreateTemplateComp";
import { ShowAlert } from "../../../common/alert";
import { fetchMutation } from "../../../actions";
import { CREATE_TEMPLATE } from "../actions/notesAct";
import { useState } from "react";

const CreateTemplateCont = ({ setShowTemplatePopup, onModalTapped, setShowTemplate }) => {
   const [loader, setLoader] = useState(false);
   const createNewTemplate = (createTemplate) => {
      setLoader(true);
      let notesObj = {
         notesTemplate: createTemplate,
      };
      fetchMutation(CREATE_TEMPLATE, notesObj, (res) => {
         const message = res?.data?.upsertNotesTemplate?.status?.message;
         setLoader(false);
         setShowTemplate(false);
         ShowAlert(message);
      });
   };

   return (
      <CreateTemplateComp
         setShowTemplatePopup={setShowTemplatePopup}
         onModalTapped={onModalTapped}
         createNewTemplate={createNewTemplate}
         setShowTemplate={setShowTemplate}
         loader={loader}
      />
   );
};

export default CreateTemplateCont;
